var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7737 24.6965C16.7737 25.525 17.3227 26.1965 17.9999 26.1965C18.6771 26.1965 19.2261 25.525 19.2261 24.6965V19.2236H24.6965C25.525 19.2236 26.1965 18.6758 26.1965 18C26.1965 17.3242 25.525 16.7764 24.6965 16.7764H19.2261V11.3032C19.2261 10.4748 18.6771 9.80322 17.9999 9.80322C17.3227 9.80322 16.7737 10.4748 16.7737 11.3032V16.7764H11.3032C10.4748 16.7764 9.80322 17.3242 9.80322 18C9.80322 18.6758 10.4748 19.2236 11.3032 19.2236H16.7737V24.6965Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b5b8350574bedd78f3ff5fa612b21c26.svg";
export { ForwardRef as ReactComponent };